import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";

function stripHtml(html = "") {
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

export default function BloggPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null); setNotFound(false);
    api.get(`/publish/public/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="blogg-notfound">
        <h1 className="text-2xl font-semibold" style={{ fontFamily: "Outfit" }}>Artikeln hittades inte</h1>
        <p className="mt-2 text-sm text-zinc-600">Den kan ha avpublicerats eller flyttats.</p>
        <Link to="/blogg" className="mt-4 inline-block text-blue-700 font-medium hover:underline">Till alla artiklar</Link>
      </div>
    );
  }
  if (!post) return <div className="flex justify-center py-24"><Loader2 className="w-5 h-5 animate-spin text-zinc-500" /></div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 animate-fade-in-up">
      <Seo
        title={post.title}
        description={post.excerpt || stripHtml(post.content).slice(0, 155)}
        path={`/api/blogg/${post.slug}`}
      />
      <nav className="flex items-center gap-1.5 text-xs text-zinc-500 mb-6" aria-label="Brödsmulor">
        <Link to="/" className="hover:text-blue-700">Start</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <Link to="/blogg" className="hover:text-blue-700">Artiklar</Link>
      </nav>
      <article data-testid="blogg-post">
        <div className="text-xs text-zinc-500">{(post.created_at || "").slice(0, 10)}</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-900" style={{ fontFamily: "Outfit" }}>
          {post.title}
        </h1>
        <div
          className="mt-6 text-zinc-700 leading-relaxed [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-zinc-900 [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-zinc-900 [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-3 [&_li]:my-1 [&_a]:text-blue-700 [&_a]:underline [&_b]:text-zinc-900 [&_strong]:text-zinc-900"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </article>
    </div>
  );
}
